import React from 'react';
import { connect } from 'react-redux';
import { getUser } from '../reducers';
import * as routes from '../constants/routes';

export default (Component) => {
  class WithAuthentication extends React.Component {
    
    componentDidMount() {
      if(!this.props.user.id){
         this.props.history.push(routes.SIGN_IN);
      }
    }

    render() { 
      return (
        <Component {...this.props}/>
      );
    }
  }

  const mapStateToProps = (state, ownProps) => {
    const user = getUser(state);
    return {...ownProps,user};
  }

  return connect(mapStateToProps, null)(WithAuthentication);
}


// WEBPACK FOOTER //
// ./src/containers/withAuthentication.js